import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";

export default function DashboardLayout({ children }) {
  const location = useLocation();
  const mainRef = useRef(null);
  const scrollPositions = useRef({});

  useEffect(() => {
    const mainElement = mainRef.current;
    if (!mainElement) return;

    // Save current scroll position before route change
    const currentPath = location.pathname;
    
    // Restore saved scroll position for this route, or stay at current position
    const savedPosition = scrollPositions.current[currentPath];
    if (savedPosition !== undefined) {
      mainElement.scrollTop = savedPosition;
    }
    // If no saved position, don't scroll (keep current position)

    // Save scroll position when scrolling
    const handleScroll = () => {
      scrollPositions.current[currentPath] = mainElement.scrollTop;
    };

    mainElement.addEventListener('scroll', handleScroll);
    return () => mainElement.removeEventListener('scroll', handleScroll);
  }, [location.pathname]);

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50 dark:bg-gray-950">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main ref={mainRef} className="flex-1 overflow-auto p-6">
          {children}
        </main>
      </div>
    </div>
  );
}
